import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/Button';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  tagName?: string;
  isDeleting?: boolean;
}

export default function DeleteConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  tagName: _tagName,
  isDeleting = false,
}: DeleteConfirmDialogProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-full max-w-screen-sm rounded shadow-xl!">
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <DialogTitle className="text-base! font-bold! text-gray-900">タグの削除</DialogTitle>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-900">本当にタグを削除しますか？</p>
        </div>

        <div className="flex justify-end gap-4 border-t border-gray-200 px-6 py-4">
          <Button color="secondary" onClick={onClose} disabled={isDeleting}>
            削除しない
          </Button>
          <Button color="danger" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除する'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
